"use strict";

exports.__esModule = true;
exports.SingletonCalendarEventEndTimeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Time = require("../../Time");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SingletonCalendarEventEndTimeField = exports.SingletonCalendarEventEndTimeField = function SingletonCalendarEventEndTimeField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "interval.endMillis"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.error ? "danger" : "secondary",
      helperText: meta.error ? meta.error : translate("SingletonCalendarEventEndTime.description", "The date / time this event ends."),
      label: translate("SingletonCalendarEventEndTime.field", "To"),
      labelFor: "interval.endMillis",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_Time.TimestampSelector, {
      selected: [new Date(input.value)],
      onSelect: function onSelect(_ref2) {
        var value = _ref2[0];
        return value && input.onChange(value.getTime());
      }
    }));
  });
};